export const MODAL_SHOW = 'MODAL_SHOW'
export const MODAL_DISMISS = 'MODAL_DISMISS'
